import { render, staticRenderFns } from "./videoComponent.vue?vue&type=template&id=814d1288&"
import script from "./videoComponent.vue?vue&type=script&lang=js&"
export * from "./videoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports